export default __webpack_public_path__ + "static/media/checkmark.3ac81912.svg";